import { showAlert } from './global/biond-global-helper';
import { BiondMealGlobalInterface } from './global/biond-meal-global-interface';
import { BiondMealGlobalEvents } from './global/biond-meal-global-events';
import { BiondMealAPI } from './meal-selection/biond-meal-selection-api';
import { BiondMealInterface } from './meal-selection/biond-meal-selection-interface';
import { BiondMealEvents } from './meal-selection/biond-meal-selection-events'; 
import { BiondQuizEvents } from './quiz/biond-quiz-events';
import { BiondQuizInterface } from './quiz/biond-quiz-interface';

window.showAlert = showAlert; 

const mealQuizWrap = document.querySelector('.meal-selection-quiz');
const mealSelectionWrap = document.querySelector('.meal-selection-selection');

if(mealQuizWrap){ 
  const biondMealGlobalInterface = new BiondMealGlobalInterface(true);
  const biondQuizInterface = new BiondQuizInterface(biondMealGlobalInterface);
  const biondQuizEvents = new BiondQuizEvents(biondQuizInterface, biondMealGlobalInterface);
  const biondGlobalEvents = new BiondMealGlobalEvents(biondQuizInterface, biondMealGlobalInterface); 
  biondGlobalEvents.init();
  biondQuizInterface.checkPreSelection();
}
if(mealSelectionWrap){
  const biondMealGlobalInterface = new BiondMealGlobalInterface(false);
  const biondApi = new BiondMealAPI();
  const mealSelectionWrapInner = document.querySelector('.meal-selection-wrap');
 
  if(mealSelectionWrapInner){
    
    const orderid = mealSelectionWrapInner.dataset.orderid; 

    biondApi.getSubscription(orderid).then(subscription => {
      
      const boxes = subscription?.data?.quizPreferences?.boxes;
      const boxId = boxes?.[0]?.box_id;
      const subscriptionStatus = subscription?.data?.status; 
      const subscriptionTimestamp = subscription?.data?.autoFillTimestamp;
      console.log(subscription);
      if(subscription?.data?.editableNow === true || customerWhiteList()){ 
        if (!boxId) {
          document.querySelector('.error-order-date').classList.add('show');
          mealSelectionWrapInner.remove();
          console.warn('❌ Keine Box-ID gefunden – Abbruch.'); 
          return;
        }

        const biondInterface = new BiondMealInterface(subscription?.data, boxId, orderid, biondMealGlobalInterface, biondApi); 

        biondMealGlobalInterface.getProducts().then(() => {
          
          //biond.renderBoxInfo();
          // 🔥 Events aktivieren
          const biondGlobalEvents = new BiondMealGlobalEvents(biondInterface, biondMealGlobalInterface);
          const biondEvents = new BiondMealEvents(biondInterface.orderId, biondInterface.lineId, biondInterface, biondGlobalEvents, biondMealGlobalInterface);
          biondMealGlobalInterface.renderBoxInfos()
          // Events initialisieren
          biondGlobalEvents.init();
          biondEvents.init();
        });
        mealSelectionWrapInner.classList.remove('first-load');
      }else{
        document.querySelector('.error-order-date').classList.add('show');
        mealSelectionWrapInner.remove();
      }

      document.querySelector('.first-load-wrap').remove();
      
    });
  }
}
function customerWhiteList(){
  const knownCustomerIds = [24012875956599, 23780603363703, 23460906828151, 23953339416951, 25197917667703]; 
  if (knownCustomerIds.includes(ShopifyAnalytics?.meta?.page?.customerId)) {
    return true;
  } 
  return false;
  
}
function isValidOrderStatus(subscriptionStatus, subscriptionTimestamp) {

  if (!subscriptionTimestamp || subscriptionStatus.toLowerCase() !== "active") {
    console.log("❌ Kein Timestamp oder Status nicht aktiv");
    return false;
  }

  const originalDate = new Date(subscriptionTimestamp);
  const now = new Date();

  const originalMs = originalDate.getTime(); // Startzeitpunkt
  const nowMs = now.getTime();               // Jetzt

  // Erlaubt bis: originalDate + 2 Tage um 06:00 UTC
  const maxAllowedMs = Date.UTC(
    originalDate.getUTCFullYear(),
    originalDate.getUTCMonth(),
    originalDate.getUTCDate() + 2,
    6, 0, 0, 0
  );

  // Debug
  console.log("originalDate:", originalDate.toISOString());
  console.log("now:", now.toISOString());
  console.log("maxAllowedMs:", new Date(maxAllowedMs).toISOString());
  console.log("-------------");

  // 1. Jetzt darf nicht vor dem Start liegen
  if (nowMs < originalMs) {
    console.log("❌ Jetzt liegt vor dem Startdatum.");
    return false;
  }

  // 2. Jetzt darf nicht nach dem Endzeitpunkt liegen
  if (nowMs > maxAllowedMs) {
    console.log("❌ Jetzt liegt nach dem erlaubten Endzeitpunkt.");
    return false;
  }

  console.log("✅ Jetzt liegt im erlaubten Zeitfenster.");
  return true;
}



document.addEventListener('DOMContentLoaded', () => {
  const box = document.querySelector('.box-wrap');
  const detector = document.querySelector('.shop-wrap');
  if (!box || !detector) return;

  const observer = new IntersectionObserver(([entry]) => {
    if (entry.boundingClientRect.top < 0) {
      // Detector ist über den Viewport hinaus → Box klebt oben
      box.classList.add('is-scroll');
    } else {
      box.classList.remove('is-scroll');
    }
  }, {
    root: null,
    threshold: 0,
    rootMargin: '0px 0px -100% 0px' // verschiebt die Trigger-Grenze
  });

  observer.observe(detector);
});


